export default function isSafariBrowser() {
    let isSafari = false;
    if (typeof window !== 'undefined' && window.navigator) {
        const { navigator } = window;
        isSafari = (
            navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
            navigator.userAgent &&
            navigator.userAgent.indexOf('CriOS') == -1 &&
            navigator.userAgent.indexOf('FxiOS') == -1
        );
    }

    return isSafari;
}



// WEBPACK FOOTER //
// ./app/lib/util/isSafariBrowser.js